angular.module('ciApp').service('Notify', ['$log', '$rootScope', Notify]);

function Notify($log, $rootScope) {
  var ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
    WARN = 'warning',
    NOTIFICATION = 'Notification';

  this.report = function(message, level) {
    $rootScope.$broadcast(NOTIFICATION, { message: message, level: level });
    switch (level) {
      case ERROR:
        $log.error(message);
        break;
      case WARN:
        $log.log('Warning: ' + message);
        break;
      default:
        $log.log(message);
    }
  };
  this.error = function(message) {
    this.report(message, ERROR);
  };
  this.warning = function(message) {
    this.report(message, WARN);
  };
  this.info = function(message) {
    this.report(message, INFO);
  };
  this.success = function(message) {
    this.report(message, SUCCESS);
  };

  this.on = function(listener) {
    $rootScope.$on(NOTIFICATION, listener);
  };
}



// WEBPACK FOOTER //
// ./common/components/notifications/notify.service.js